import HighlightSectionSkeleton from '../highlight-section-skeleton/highlight-section-skeleton';

const FullPageLoader = () => {
    return <HighlightSectionSkeleton />;
};

export default FullPageLoader;
